// import { useMutation } from '@tanstack/vue-query';
import {
  postV7DataMetrics,
  postV7DataMetricsBatch,
} from '@/api-client/data/queries/data-v7-controller/data-v7-controller';
import { getHashedString } from '@/common/api/utils/utils';
import type { MetricV7Request } from '@/api-client/data/model';

export interface MetricDataRequest {
  metricV7Requests?: MetricV7Request[];
  frameName?: string;
  isPolling?: boolean;
  isTimeout?: boolean;
  signal?: AbortSignal;
  key?: string;
}

/**
 * 메트릭 데이터 조회
 */
export const getMetricData = async ({
  metricV7Requests,
  frameName,
  isPolling,
  isTimeout,
  signal,
}: MetricDataRequest) => {
  const body = metricV7Requests ?? [];

  const hashed = getHashedString<MetricDataRequest>({
    metricV7Requests: body,
    frameName,
    isPolling,
    isTimeout,
  });

  return postV7DataMetrics(
    body,
    {
      params: {
        frameName,
        isPolling,
        isTimeout,
        hashedRequest: hashed,
      },
    },
    signal,
  );
};

/**
 * 메트릭 데이터 조회 composable
 */
// export const useGetMetricData = () => {
//   const { mutateAsync } = useMutation({
//     mutationFn: getMetricData,
//   });
//
//   return { getMetricData: mutateAsync };
// };

export const getMetricBatchData = async ({
  metricV7Requests,
  frameName,
  isPolling,
  isTimeout,
  signal,
}: MetricDataRequest) => {
  const body = metricV7Requests ?? [];

  const hashed = getHashedString<MetricDataRequest>({
    metricV7Requests: body,
    frameName,
    isPolling,
    isTimeout,
  });

  return postV7DataMetricsBatch(
    body,
    {
      params: {
        frameName,
        isPolling,
        isTimeout,
        hashedRequest: hashed,
      },
    },
    signal,
  );
};
